import { render } from "./ConfigSOA.vue?vue&type=template&id=17bb1885"
import script from "./ConfigSOA.vue?vue&type=script&lang=js"
export * from "./ConfigSOA.vue?vue&type=script&lang=js"

import "./ConfigSOA.vue?vue&type=style&index=0&id=17bb1885&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__